// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter--HfWKi","labelSection":"labelSection--tOz7G","label":"label--sQfDS","description":"description--Lgptr","warning":"warning--IYzvZ","info":"info--xlIeK"};